// extracted by mini-css-extract-plugin
export default {"form":"AuthForm_form__10QFm","text":"AuthForm_text__LM085","hr":"AuthForm_hr__IVOrb"};